import React, { createContext, useState } from "react";
import { nonEmpty } from "../../utils/service";
import { useLocation, useNavigate } from "react-router-dom";
import RouteConstants from "../../constants/routesContent.json";
import {
  createDeviceApi,
  editDeviceApi,
  getDeviceListApi,
} from "../../api/Api";
import { useEffect } from "react";

export const AddDeviceContext = createContext({});
export const AddDeviceContextProvider = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const informationDevice = location?.state;
  const devceinfomation = informationDevice?.deviceData;
  const isEdit = informationDevice?.isEdit;
  const [zone, setZone] = useState(
    devceinfomation && devceinfomation?.Zone ? devceinfomation.Zone : "Select"
  );
  const [activity, setActivity] = useState(
    devceinfomation && devceinfomation?.Activity
      ? devceinfomation.Activity
      : "Select"
  );
  const [responseMessage, setResponseMessage] = useState("");
  const [alert, setAlert] = useState(false);
  const [isEditor, setIsEditor] = useState(isEdit);
  const [deviceList, setDeviceList] = useState("");
  const [deviceId, setDeviceId] = useState(
    devceinfomation && devceinfomation?.DeviceId ? devceinfomation.DeviceId : 0
  );
  const [activityRequired, setActivityRequired] = useState(false);
  const [zoneRequired, setZoneRequired] = useState(false);
  const [ipAddress, setIpAdress] = useState(
    devceinfomation && devceinfomation?.ip ? devceinfomation.ip : ""
  );

  const [entryType, setEntryType] = useState(
    devceinfomation && devceinfomation?.EntryType
      ? devceinfomation.EntryType
      : ""
  );
  const [requriedIpAdress, setRequriedIpAdress] = useState(false);
  const [requriedEntyType, setRequriedEmptyEntyType] = useState(false);

  useEffect(() => {
    // setDeviceId(devceinfomation?.DeviceId)
    // setIpAdress(devceinfomation?.ip)
    // setEntryType(devceinfomation?.EntryType)
    // setActivity(devceinfomation?.Activity)
    // setZone(devceinfomation?.Zone)
  }, [devceinfomation]);

  const goBack = () => {
    navigate(-1);
  };
  const validationIpAdressCheck = () => {
    if (nonEmpty(ipAddress)) {
      setRequriedIpAdress(false);
      return true;
    } else {
      setRequriedIpAdress(true);
      return false;
    }
  };
  const validationEntyTypeCheck = () => {
    if (nonEmpty(entryType)) {
      setRequriedEmptyEntyType(false);
      return true;
    } else {
      setRequriedEmptyEntyType(true);
      return false;
    }
  };

  const getDeviceData = async () => {
    try {
      const response = await getDeviceListApi();
      if (response.data.status === 200) {
        setDeviceList(response?.data?.data);
        setAlert(true);
        setResponseMessage(response.data.message);
      }
    } catch (error) {
      if (
        error.response.data.status === 400 ||
        error.response.data.status === 401
      ) {
        setResponseMessage(error.response.data.message);
        setAlert(true);
      } else {
        setResponseMessage("Somthing went wrong");
        setAlert(true);
      }
    }
  };

  const editDeviceData = async () => {
    const validationIpAdress = validationIpAdressCheck();
    const validateEntryType = validationEntyTypeCheck();
    if (!validationIpAdress && !validateEntryType) {
      return;
    }
    const data = {
      ip: ipAddress,
      entryType: entryType,
      activity: activity?.name,
      zone: zone?.name,
      status: "",
    };

    try {
      const response = await editDeviceApi(data, deviceId);
      if (response.data.status === 200) {
        setAlert(true);
        setResponseMessage(response.data.message);
      }
    } catch (error) {
      if (
        error.response.data.status === 400 ||
        error.response.data.status === 401
      ) {
        setResponseMessage(error.response.data.message);
        setAlert(true);
      } else {
        setResponseMessage("Somthing went wrong");
        setAlert(true);
      }
    }
  };

  const btnAddDeviceSave = async () => {
    const validationIpAdress = validationIpAdressCheck();
    const validateEntryType = validationEntyTypeCheck();
    if (!validationIpAdress && !validateEntryType) {
      return;
    }
    const data = {
      ip: ipAddress,
      entryType: entryType,
      activity: activity?.name,
      zone: zone?.name,
      status: "",
    };
    try {
      const response = await createDeviceApi(data);

      if (response.data.status === 200) {
        setAlert(true);
        setResponseMessage(response.data.message);
      }
    } catch (error) {
      if (
        error.response.data.status === 400 ||
        error.response.data.status === 401
      ) {
        setResponseMessage(error.response.data.message);
        setAlert(true);
      } else {
        setResponseMessage("Somthing went wrong");
        setAlert(true);
      }
    }
  };

  const navigateToListDevice = () => {
    navigate(RouteConstants.SETTINGS);
  };

  const btnAddDeviceCancel = () => {
    goBack();
  };

  const providerValue = {
    deviceId,
    zone,
    setZone,
    activity,
    setActivity,
    ipAddress,
    setIpAdress,
    entryType,
    setEntryType,
    btnAddDeviceSave,
    editDeviceData,
    btnAddDeviceCancel,
    requriedIpAdress,
    devceinfomation,
    setRequriedIpAdress,
    navigateToListDevice,
    requriedEntyType,
    deviceList,
    setRequriedEmptyEntyType,
    isEdit,
    activityRequired,
    getDeviceData,
    responseMessage,
    setActivityRequired,
    alert,
    setAlert,
    zoneRequired,
    setZoneRequired,
    goBack,
    isEditor,
    setIsEditor,
  };

  return (
    <AddDeviceContext.Provider value={providerValue}>
      {children}
    </AddDeviceContext.Provider>
  );
};
